export default class Order {
    init() {
        var today = moment();
        $('#event_date').daterangepicker({
            singleDatePicker: true,
            start: today,
            locale: modules.common.daterangepicker_locale
        });
    };
};